import { documentsStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDocuments";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    css: css`
        ${mediaQueriesBP.maxMD} {
            padding: 10px 0 30px;
        }

        ${mediaQueriesBP.minMD} {
            padding: 20px 25px;
        }
    `,
};

styles.container = {
    ...styles.container,
    gap: 15,
    offsetCss: css`
        ${mediaQueriesBP.maxMD} {
            width: calc(100% + 20px);
            margin: -10px;
        }
    `,
};

styles.documentGridItem = {
    ...styles.documentGridItem,
    width: [6, 6, 12, 12, 12],
    css: css`
        ${mediaQueriesBP.maxMD} {
            padding: 10px;
        }
    `,
};

styles.documentIcon = {
    ...styles.documentIcon,
    size: 30,
};

styles.documentLink = {
    ...styles.documentLink,
    typographyProps: {
        ...styles.documentLink?.typographyProps,
        size: "16px",
        lineHeight: "18px",
    },
    icon: {
        iconProps: {
            ...styles.documentIcon,
        },
    },
    css: css`
        && {
            align-items: center;
        }
    `,
};

styles.documentNameText = {
    ...styles.documentNameText,
    css: css``,
};
